export default __webpack_public_path__ + "static/media/crown2.a3ef0d85.png";